import { useTranslation } from 'react-i18next'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import Tabs from 'components/organisms/tabs/Tabs'
import SessionForm from 'components/organisms/forms/SessionForm'
import SessionAttendanceForm from 'components/organisms/forms/SessionAttendanceForm'
import SessionBehaviourForm from 'components/organisms/forms/SessionBehaviourForm'
import LessonPlanTab from 'components/utilized/lessonPlans/LessonPlanTab'

import { useGET_groupCourseSessionByIdQuery } from 'redux/api/sessionsApi'
import { useGET_lessonPlanByIdQuery } from 'redux/api/lessonPlansApi'

import { crudActionsMap, printDiv } from 'utils/helpers'
import { useHash } from 'utils/customHooks/useHash'
import { Box, Button } from '@mui/material'
import LessonPlanTemplate from 'components/utilized/lessonPlans/LessonPlanTemplate'
import { Print } from '@mui/icons-material'
import { FaChevronLeft } from 'react-icons/fa'

const SessionCrudPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const params = useParams()
  const [searchParams] = useSearchParams();
  
  const id = params?.id
  const group_course_id = searchParams.get('group_course')

  
  const {hash} = useHash();
  
  const user = useSelector((state: RootState) => state['user'].user)
  const backUrl = useSelector((state: RootState) => state['sessions'].sessionBackUrl)

  const { data: session } = useGET_groupCourseSessionByIdQuery(id, { skip: !id })
  const { data: plan } = useGET_lessonPlanByIdQuery(session?.group_course_session_plan?.id.toString(), { skip: !session || !session.id || !session.group_course_session_plan})

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = user?.role === 'special_teacher' || action === 'view'

  return ( <>
      { session && session.group_course && 
        <PageHeading title={`${t('common.groups')} / 
          ${session.group_course.title }
          `} />
      }
        { user && <PageBody>

          {['student','parent'].includes(user.role) && plan && <>
            <div id="lesson-plan">
              <LessonPlanTemplate entity={plan} />
            </div>
            <div style={{ marginTop: '20px' }}>
              <Button
                  variant='outlined'
                  color='black'
                  onClick={() => navigate(backUrl || '/my-curriculum-map')}
                  sx={{ minHeight: '2.5rem', width: '10rem' }}
                >
                  <FaChevronLeft style={{ fontSize: '1.1rem', margin: '-3px 0.5rem 0 -0.5rem' }} />
                  {`${t('common.back')}`}
              </Button>
              <Button
                          variant='outlined'
                          color='black'
                          onClick={ () => { printDiv('lesson-plan') } }
                            sx={{ minHeight: '2.5rem', width: '10rem', marginLeft: '10px' }}
                          >
                          <Print style={{ fontSize: '1.1rem', margin: '-3px 0.5rem 0 -0.5rem' }} />
                          {`${t('common.print')}`}
              </Button>
            </div>

          </>
          }

        {!['student','parent'].includes(user.role) && <>
          <SessionForm action={action} id={id} group_course_id={group_course_id} viewOnly={viewOnly} />
          { session &&
          <Tabs tabKey={hash || 'plan'}>
            {/*<CourseInfo id={session.group_course.course.id} course_chapter_id={session.course_chapter_id} tabKey="info" tabText={`${t('common.overview')}`} />*/}
            
            <LessonPlanTab session={session} plan={plan} tabKey="plan" tabText={`${t('common.lesson-plan')}`} />
            <SessionAttendanceForm session={session} viewOnly={viewOnly} tabKey="attendance" tabText={`${t('common.attendance')}`} />
            <SessionBehaviourForm session={session} viewOnly={viewOnly} tabKey="behaviour" tabText={`${t('common.behaviour')}`} /> 

          </Tabs>
          } </> }
          
        </PageBody>
        } 
      </> 
    
  )
}
export default SessionCrudPage

